import { PageHeader as UiPageHeader } from '@dreamtree-org/twreact-ui';
import RouterLink from './RouterLink';

/**
 * twreact-ui PageHeader with router links (`back: { href, label }`). With no title (a page embedded
 * as a tab) only the actions render. `actionsPlacement="bottom"` pins the actions above the phone
 * keyboard/home bar; keep it for pages with one primary action.
 */
export default function PageHeader({ title, subtitle, back, actions, actionsPlacement, className }) {
  if (!title) return actions ? <div className={`flex flex-wrap items-center justify-end gap-2 ${className || ''}`}>{actions}</div> : null;
  return (
    <UiPageHeader
      title={title}
      subtitle={subtitle}
      back={back}
      actions={actions}
      actionsPlacement={actionsPlacement}
      linkAs={RouterLink}
      className={className}
    />
  );
}
